import {Hero} from '@primer/react-brand'

import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'

import type {FlexSuiteStackedHeroProps} from './types'
import {HeroContent} from './HeroContent'

/**
 * Stacked hero: center-aligned with a block-end image
 */
export function FlexSuiteHeroStacked({fields}: {fields: FlexSuiteStackedHeroProps}) {
  const {heroImage} = fields

  return (
    <HeroContent {...fields} data-testid="hero-stacked">
      {heroImage && (
        <Hero.Image
          as="picture"
          src={`${heroImage.fields.file.url}?fm=webp`}
          sources={getImageSources(heroImage.fields.file.url, {maxWidth: MAX_CONTENT_WIDTH, disableDprScaling: true})}
          alt={heroImage.fields.description ?? ''}
          enableBorder={false}
        />
      )}
    </HeroContent>
  )
}
